export enum CAMPAIGN_TEMPLATE {
  GENERAL = "CampaignBriefGeneral",
  BRAND = "CampaignBriefBrand",
  NEW_PRODUCT = "CampaignBriefNewProduct",
  SIMPLE = "CampaignBriefSimple",
}
